import React from 'react';

// React error boundaries have no hook equivalent — they must be class
// components. Catches render/lifecycle errors in the subtree below it and
// shows a recoverable fallback instead of leaving the whole page blank.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('❌ Error capturado por ErrorBoundary:', error, info);
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="container text-center py-5">
          <h3>Ocurrió un error inesperado</h3>
          <p className="text-muted">
            Algo falló al mostrar esta página. Intente recargar — si el problema persiste,
            contacte al administrador del sistema.
          </p>
          <button type="button" className="btn btn-primary" onClick={this.handleReload}>
            Recargar Página
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
